import _classCallCheck from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/inherits";
import * as React from 'react';
import * as PropTypes from "prop-types";
import { RangeHistogram, RangeSlider, RangeInput } from './';
import { RangePropTypes } from './RangeProps';
export var RangeComponent =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(RangeComponent, _React$PureComponent);

  function RangeComponent() {
    _classCallCheck(this, RangeComponent);

    return _possibleConstructorReturn(this, _getPrototypeOf(RangeComponent).apply(this, arguments));
  }

  _createClass(RangeComponent, [{
    key: "render",
    value: function render() {
      var props = this.props;
      var showHistogram = props.showHistogram,
          showSlider = props.showSlider,
          showInput = props.showInput;
      return React.createElement("div", null, showHistogram ? React.createElement(RangeHistogram, Object.assign({}, props)) : undefined, showSlider ? React.createElement(RangeSlider, Object.assign({}, props)) : undefined, showInput ? React.createElement(RangeInput, Object.assign({}, props)) : undefined);
    }
  }]);

  return RangeComponent;
}(React.PureComponent);
RangeComponent.propTypes = Object.assign({
  showHistogram: PropTypes.bool,
  showSlider: PropTypes.bool,
  showInput: PropTypes.bool
}, RangePropTypes);
export function RangeComponentBuilder(components) {
  return function (props) {
    return React.createElement(RangeComponent, Object.assign({}, props, components));
  };
}
export var RangeSliderHistogram = RangeComponentBuilder({
  showHistogram: true,
  showSlider: true
});
export var RangeSliderHistogramInput = RangeComponentBuilder({
  showHistogram: true,
  showSlider: true,
  showInput: true
});
export var RangeSliderInput = RangeComponentBuilder({
  showSlider: true,
  showInput: true
});
export var RangeHistogramInput = RangeComponentBuilder({
  showHistogram: true,
  showInput: true
});